export default __webpack_public_path__ + "static/media/file-video.22c374ed.svg";